import moment from 'moment'
import React, {
  useEffect,
  useState,
} from 'react'
import { connect } from 'react-redux'
import { CSVLink } from "react-csv"
import {
  withRouter,
} from 'react-router-dom'
import BaseTable from '../../components/BaseTable'
import MainHeader from '../../components/MainHeader'
import {
  fetchDealers,
  fetchJobById,
  fetchJobs,
  getOrders,
  redirectToVariance,
  updateJob,
} from '../../store/actions'
import './index.css'
import tableColumns from './data'

const pageTitles = {
  jobs: 'Job Report #',
  dealers: 'Dealer Report #',
  employee: 'Employee Report #',
  generic: 'Generic Report #',
}

const Report = (props) => {
  let page = props.match.params.jobId ? 'jobs' : props.match.params.dealerId ? 'dealers' : props.match.params.employeeId ? 'employee' : 'generic'
  let reportName = props.match.params.reportId

  const tableOptions = {
    columns: [ ...tableColumns[reportName] ],
  }

  const [ tableData, setTableData ] = useState([])
  const [csvData, setCsvData] = useState([])

  useEffect(() => {
    let newData = {}
    const data = props.jobReports && props.jobReports[0]
    const rows = data && data.rows
    const columnNames = data && data.columnNames

    let result = []

    if (rows) {
      result = rows.map((valueArray) => {
        const obj = {}
        columnNames.forEach((key, index) => {
          obj[key] = valueArray[index]
        })

        return obj
      })

      let newCsvData = [
        [...props.jobReports[0].columnNames],
        ...props.jobReports[0].rows
      ];

      setCsvData(newCsvData);
    }

    setTableData(result)
  }, [ props.jobReports ])

  console.log('tableData',tableData)
  console.log('tableOptions',tableOptions)

  return (
    <div>
      <div className="reports-header">
        <MainHeader title={pageTitles[page] + reportName} backLink="/jobs" />
        <div className="reports-header-content">
          <div className="reports-header-generated">
            Generated {moment().format('LLL')}
          </div>


          <CSVLink
            filename={pageTitles[page] + reportName + ".csv"}
            data={csvData}>
            <div className="btn btn--primary reports-header-download">
              Download Report
            </div>
          </CSVLink>

        </div>
      </div>
      {(props.jobReports && props.jobReports[0]) && (
        <BaseTable
          onSort={() => {
            console.log('')
          }}
          onSelectStatus={() => {
            console.log('')
          }}
          data={tableData}
          options={tableOptions}
          className="reports__table"
          rowOnClick={() => {
            console.log('')
          }} />
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  jobReports: state.reports.jobReports,
})

const mapDispatchToProps =
  {
    fetchJobs, fetchDealers, updateJob, fetchJobById, redirectToVariance,
    getOrders,
  }

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Report))
